module.exports = __webpack_public_path__ + "img/no-data_lock.ee32b98d.svg";